import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import * as Header from "../Layout/Header";
import { useDocumentMeta } from '../useDocumentMeta';
function Portfolio(props) {
  props.setColorData("#48486a");
  props.setHeaderClassName("");
  const [portfolio, setPortfolio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();


  useEffect(() => {
    // 이전 페이지에서 왔는지 체크
    const fromDetail = sessionStorage.getItem('fromDetail');

    // accesekey검증 
    const savedKey = props.accessKey || sessionStorage.getItem("accessKey");

    const fetchUsers = async () => {
        try {
            setError(null);
            setPortfolio(null);
            setLoading(true);
            const response = await axios.get("https://api.0u0.kr//portfolio/list");
            setPortfolio(response.data.data);
        } catch (e) {
            setError(e);
        }
        setLoading(false);
    };

    fetchUsers().then(() => {
        if (fromDetail) {
          const scrollY = sessionStorage.getItem('scrollPosition');
          if (scrollY) {
              window.scrollTo(0, parseInt(scrollY));
          }
          sessionStorage.removeItem('fromDetail');
          sessionStorage.removeItem('scrollPosition');
      }
    });


}, []);

const saveScrollPosition = () => {
    const pos = window.pageYOffset;
    sessionStorage.setItem('scrollPosition', pos);
    sessionStorage.setItem('fromDetail', 'true');
};

  // Link 컴포넌트에 현재 스크롤 위치를 state로 전달
  const getScrollPosition = () => {
    return window.pageYOffset || document.documentElement.scrollTop;
  };

  useDocumentMeta("Portfolio", "#48486a");


  if (loading) return <div>로딩중..</div>;
  if (error) return <div>에러가 발생했습니다</div>;
  if (!portfolio) return null;
  return (
    <>
      <div className="whiteBg">
        <div className="basicWidth">
          <div className="postBox">
            <ul>
              {portfolio
		.filter((pt) => pt.pjFile !== "OilSagu")
		.map((pt) => (
                <li  key={pt.pjFile}>
                  <Link 
                   to={`/Portfolio/${pt.pjFile}`} onClick={saveScrollPosition}
                  >
                    <div className="pbBox">
                      <div className="imgBox">
                        <img
                          className="thumImg"
                          src={"https://img.0u0.kr/new_port/" + pt.thumNail}
                          alt={pt.pjName + "의 배경"}
                        />
                        <div
                          className="bgColorBox"
                          style={{ backgroundColor: pt.thmnailBgColor }}
                        ></div>
                        <div className="logoBox">
                          <div className="logoBoxPt">
                            <img
                              src={"https://img.0u0.kr/new_port/" + pt.imgLogo}
                              alt={pt.pjName + "의 로고"}
                            />
                          </div>
                        </div>
                      </div>
                      <h2>{pt.pjName}</h2>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
export default Portfolio;
